import {type IState} from '../models/IState';
import {type DispatchAction} from '../store';

import {cartReducer} from './cartReducer';
import {merchantConfigurationReducer} from './merchantConfigurationReducer';
import {environmentReducer} from './environmentReducer';

import {createDispatchUpdate, initialState} from './initialState';
import {paymentConfigurationReducer} from './paymentConfigurationReducer';
import {DispatchActionType} from '../models/DispatchActionType';

// eslint-disable-next-line @typescript-eslint/default-param-last
export function rootReducer(state: IState = initialState, action: DispatchAction<unknown>): IState {
	return {
		// All existing data.
		...state,

		// Let sub reducers handle nested reducing and handling related actions.
		environment: environmentReducer(state.environment, action),
		merchantConfiguration: merchantConfigurationReducer(state.merchantConfiguration, action),
		calculatedCarts: cartReducer(state.calculatedCarts, action),
		paymentConfiguration: paymentConfigurationReducer(state.paymentConfiguration, action),
	};
}

/**
 * Dispatch action that changes zero state. Used to force a rerender when something outside of the redux store may have changed.
 */
export const render = createDispatchUpdate<void>(DispatchActionType.INIT);
